import { useMemo } from 'react';

import { IKnmMassCancel } from '../../../APIPackage/KnmModule/interfaces/IKnmMassCancel';
import { DatePicker } from '../../../UIPackage/MainModule/components/DatePicker';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { TextInput } from '../../../UIPackage/MainModule/components/TextInput';
import { UploadFile } from '../../../UIPackage/MainModule/components/UploadFile';
import { useKnmDocumentAttachment } from '../hooks/useKnmDocumentAttachment';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';
import styles from './MassCancelInfo.module.scss';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';

interface IMassCancelInfoProps {
  massCancel: IKnmMassCancel | null | undefined;
}

export const MassCancelInfo = ({ massCancel }: IMassCancelInfoProps) => {
  const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();
  const downloadAttachment = (attachment: IKnmAttachment) => () => {
    const { fileName, fileSize, filePath, mimeType } = attachment;

    downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
  };

  const cancelledValue = useMemo(
    () =>
      formatDate({
        date: massCancel?.cancelled || '',
        dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
        parseFormat: DATE_FORMAT_ISO_FNS,
      }),
    [massCancel],
  );

  if (!massCancel?.cancelled) {
    return null;
  }

  return (
    <>
      <FieldBlock label="Сведения об отмене мероприятия" margin="bottom" className={styles.MassCancelInfoBlock}>
        <FieldBlock label="Дата и время отмены" color="black" placementLabel="left" margin="bottom" labelSize="col-3">
          <DatePicker name="" value={cancelledValue} className="shared-row-field" disabled />
        </FieldBlock>
        <FieldBlock
          label="Основание массовой отмены"
          color="black"
          placementLabel="left"
          margin="bottom"
          labelSize="col-3"
        >
          <TextInput className="shared-row-field" value={massCancel.reason?.name} disabled />
        </FieldBlock>
        {massCancel.reasonFile && (
          <FieldBlock
            label="Файл основания массовой отмены"
            color="black"
            placementLabel="left"
            margin="bottom"
            labelSize="col-3"
          >
            <UploadFile
              fileName={massCancel.reasonFile.fileName || ''}
              fileSize={massCancel.reasonFile.fileSize}
              onFileNameClick={downloadAttachment(massCancel.reasonFile)}
              className="shared-row-field"
            />
          </FieldBlock>
        )}
        <FieldBlock
          label="Номер группы мероприятий, подлежащих отмене"
          color="black"
          placementLabel="left"
          margin="bottom"
          labelSize="col-3"
        >
          <TextInput className="shared-row-field" value={massCancel.groupId} disabled />
        </FieldBlock>
        {massCancel.particularCancelDecisionFile && (
          <FieldBlock
            label="Файл решения об отмене"
            color="black"
            placementLabel="left"
            margin="bottom"
            labelSize="col-3"
          >
            <UploadFile
              fileName={massCancel.particularCancelDecisionFile.fileName || ''}
              fileSize={massCancel.particularCancelDecisionFile.fileSize}
              onFileNameClick={downloadAttachment(massCancel.particularCancelDecisionFile)}
              className="shared-row-field"
            />
            {massCancel.particularCancelDecisionFile.signatureInfo?.[0] && (
              <UploadFile fileName={''} fileSize={massCancel.particularCancelDecisionFile.fileSize} />
            )}
          </FieldBlock>
        )}
      </FieldBlock>
    </>
  );
};
